import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { FaCartShopping } from "react-icons/fa6";
import { PiBehanceLogo } from "react-icons/pi";

const Header = () => {
    return (
        <>
            <div className='header_bg mb-3 bg-dark'>
                <Container>
                    <Row>
                        <Col>
                            <div className='d-flex justify-content-between '>    
                                <div className='py-3'>
                                    <h2><Link to={'/'}><PiBehanceLogo className='text-white' /></Link></h2>
                                </div>
                                <div className='py-3'>
                                    <h2><Link  to={'/cart'}><FaCartShopping className='text-white' /></Link></h2>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default Header